import { createApp } from "vue";
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "element-plus/dist/index.css";
import App from "./App.vue";
import store from "./store";
import "./assets/styles.css";

createApp(App).use(store).use(ElementPlus, { locale: zhCn }).mount("#app");
